<div class="di-diary">
  <ng-container *ngIf="showFilters">
    <div class="row no-gutters mb-3">
      <div class="col-5 col-sm-3 pr-2">
        <si-selector id="selectorDiaryView"
                     name="selectorDiaryView"
                     tourAnchor="diary.visualization"
                     placeholder="SI_SELECT_PLACEHOLDER"
                     [(model)]="filters.selectView"
                     [values]="selectorValues"
                     (modelChange)="onSelectView()"
                     [hideLabel]="true"
                     [showDropdownSearch]="false"
                     [showClear]="false"
        ></si-selector>
      </div>
      <div class="col-7 col-sm-4">
        <ng-container *ngIf="filters.selectView.id == diaryViewKeys.LISTMONTH; else defaultDatepickerView">
          <si-datepicker id="diaryChangeDateList"
                         name="diaryChangeDateList"
                         placeholder="CORE_DATEPICKER_MM_YYYY"
                         [(model)]="filters.date"
                         (modelChange)="onChangeDate($event)"
                         startOf="day"
                         view="month"
                         [hideLabel]="true"
                         [showClear]="false"
          ></si-datepicker>
        </ng-container>
        <ng-template #defaultDatepickerView>
          <si-datepicker id="diaryChangeDate"
                         name="diaryChangeDate"
                         placeholder="CORE_DATEPICKER_L"
                         [(model)]="filters.date"
                         (modelChange)="onChangeDate($event)"
                         startOf="day"
                         [hideLabel]="true"
                         [showClear]="false"
          ></si-datepicker>
        </ng-template>
      </div>
    </div>
    <div *ngIf="filters.selectView.id !== diaryViewKeys.LISTYEAR" class="d-flex justify-content-between mb-3">
      <div>
        <button class="si-button_active-thick align-items-center"
                type="button"
                (click)="onClickPrev()">
          <i class="icosun-arrow_to_left mr-2"></i>
          <span>{{'SI_PREVIOUS' | translate}}</span>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <span class="di-diary-page_sub-title">{{calendarTitle}}</span>
      </div>
      <div>
        <button class="si-button_active-thick align-items-center"
                type="button"
                (click)="onClickNext()">
          <span>{{'SI_NEXT' | translate}}</span>
          <i class="icosun-arrow_to_right ml-2"></i>
        </button>
      </div>
    </div>
  </ng-container>
  <div class="mb-3" *ngIf="showCaption">
    <si-states-caption [entity]="statesCaptionEntities.DIARY_EVENT"
                       path="/api/v1/list/EVENT_STATUS/items"
    ></si-states-caption>
  </div>
  <div>
    <full-calendar #fullCalendar [options]="calendarOptions" class="pasi-diary"></full-calendar>
  </div>
</div>
